import { c as _c } from "react/compiler-runtime";
import { FaSearch } from "react-icons/fa";
import { Button, Kbd } from "@/components/ui";
import { cx } from "@/lib/tailwind-utils";
import { useNavigationSearchOpenStore } from "@/stores/navigation-search-store";
export function CommandBar(t0) {
  const $ = _c(11);
  const {
    className,
    size: t1
  } = t0;
  const size = t1 === undefined ? "base" : t1;
  const {
    openSearch
  } = useNavigationSearchOpenStore();
  let t2;
  if ($[0] !== className) {
    t2 = cx("h-9 w-full justify-start rounded-lg px-3 py-2 text-left text-body text-foreground-secondary shadow-sm", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== openSearch) {
    t3 = () => openSearch("click");
    $[2] = openSearch;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FaSearch className="h-3.5 w-3.5" />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== size) {
    t5 = size === "base" && <><span className="text-body">Search</span><Kbd command="K" className="ml-auto hidden md:inline-flex" /></>;
    $[5] = size;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t5) {
    t6 = <Button variant="secondary" className={t2} onClick={t3} icon={t4}>{t5}</Button>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}